@if (!store.isSummary) {
    <ap-previous-button (click)="previousQuestion()"></ap-previous-button>
    <div class="bold">{{ 'financial-obligations.personal-loan.title' | apContent }}</div>
}

@if (showPersonalLoanMonthlyAmount()) {
    <personal-loan-monthly-payment></personal-loan-monthly-payment>
}
@if (showPersonalLoanTotalAmount()) {
    <personal-loan-amount></personal-loan-amount>
}
